import { type Testimonial } from '@common/types/testimonial.type';

import { createActionGroup, props } from '@ngrx/store';

const TestimonialsActions = createActionGroup({
    source: 'Testimonials/CollectionQuery/API',
    events: {
        'Load Collection Request': props<{ courseId: number }>(),
        'Load Collection Success': props<{ courseId: number; testimonials: Testimonial[] }>(),
        'Load Collection Failure': props<{ courseId: number; error: string }>(),
    },
});

export default TestimonialsActions;
